import { apiClient } from '../../axios';
import {
  GetExchangeRatesResponse,
  GetLuckyDrawMissionsResponse,
  GetLuckyDrawResponse,
  GetTradeToEarnResponse,
  PostLuckyDrawResponse,
  PutLuckyDrawTokensRequest,
  PutLuckyDrawTokensResponse,
} from './types';

export const getTradeToEarnApi = (eventId: string) =>
  apiClient.get<GetTradeToEarnResponse>(`/v1/campaign/trade-to-earn/${eventId}`);

export const postTradeToEarnApi = (eventId: string) => apiClient.post(`/v1/campaign/trade-to-earn/${eventId}`);

export const getLuckyDrawApi = ({ eventId, installId }: { eventId: string; installId: string }) =>
  apiClient.get<GetLuckyDrawResponse>(`/v1/lucky-draw/${eventId}?installId=${installId}`);

// 룰렛 회전 요청 api
export const postLuckyDrawApi = ({ eventId, installId }: { eventId: string; installId: string }) =>
  apiClient.post<PostLuckyDrawResponse>(`/v1/lucky-draw/${eventId}`, { installId });

export const postRegisterLuckyDrawApi = ({ slugIds }: { slugIds: string[] }) =>
  apiClient.post('/v1/lucky-draw', { ids: slugIds });

export const getExchangeRatesApi = ({ eventId }: { eventId: string }) =>
  apiClient.get<GetExchangeRatesResponse>(`/v1/lucky-draw/tokens/exchange-rates/${eventId}`);

export const putLuckyDrawTokensApi = ({ from, to }: PutLuckyDrawTokensRequest) =>
  apiClient.put<PutLuckyDrawTokensResponse>('/v1/lucky-draw/tokens', { from, to });

export const getLuckyDrawMissionsApi = ({ eventId }: { eventId: string }) =>
  apiClient.get<GetLuckyDrawMissionsResponse>(`/v1/lucky-draw/missions/${eventId}`);
